import $ from 'jquery';
import 'slick-slider';

const CAROUSEL_CSS_CLASS = $('.partner-carousel');

class Carousel {

    constructor(class_name) {
        this.carousel = class_name;
        this.start();

    }

    start() {
        this.carousel.slick({
            slidesToShow: 6,
            slidesToScroll: 1,
        });
    }
}

$(document).ready(
    () => new Carousel(CAROUSEL_CSS_CLASS));

